
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/what-will-i-look-like-when-im-older",
      function () {
        return require("private-next-pages/what-will-i-look-like-when-im-older/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/what-will-i-look-like-when-im-older"])
      });
    }
  